import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { startCase, map } from 'lodash/fp';

import { DimensionType, Dimension, DimensionGccDropdown } from './styles';

import { getDimensionInches, getDimensionFractions } from '../../helpers/mandi/getWindowDimensions';

const fractions = getDimensionFractions();

const DimensionEditor = ({
  label,
  minInches,
  maxInches,
  value,
  onChange,
}) => {
  const dimensionInches = useMemo(
    () => getDimensionInches(minInches, maxInches),
    [minInches, maxInches],
  );

  const inchesValue = useMemo(() => parseInt(value), [value]);
  const fractionValue = useMemo(() => value - Math.floor(value), [value]);

  const updateInches = useCallback(
    e => onChange(parseInt(e.target.value) + fractionValue),
    [fractionValue],
  );
  const updateFraction = useCallback(
    e => onChange(parseFloat(e.target.value) + inchesValue),
    [inchesValue],
  );

  return (
    <Dimension>
      <DimensionType>{startCase(label)}</DimensionType>
      <DimensionGccDropdown>
        <select
          id={`${label}Inches`}
          name={`${label}Inches`}
          value={inchesValue}
          onChange={updateInches}
        >
          <option />
          {map(option => (
            <option key={option.value} value={option.value}>{option.display}</option>
              ))(dimensionInches)}
        </select>
        <label htmlFor={`${label}Inches`}>Inches</label>
      </DimensionGccDropdown>
      <DimensionGccDropdown>
        <select
          id={`${label}Eighths`}
          name={`${label}Eighths`}
          value={fractionValue}
          onChange={updateFraction}
        >
          <option />
          {map(option => (
            <option key={option.value} value={option.value}>{option.display}</option>
              ))(fractions)}
        </select>
        <label htmlFor={`${label}Eighths`}>Eighths</label>
      </DimensionGccDropdown>
    </Dimension>
  );
};

DimensionEditor.propTypes = {
  label: PropTypes.string.isRequired,
  minInches: PropTypes.number.isRequired,
  maxInches: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DimensionEditor;
